import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
  
}
const mutations = {
 
}

export default {
  namespaced: true,
  state,
  mutations,
}
